import { useSelector, useDispatch } from 'react-redux'

export async function fetchDefaultMenuURL(menuCode) {
    console.log(menuCode)
    switch (menuCode) {
        case 'MUP':
            return "/masterManagement-menu-item1"
            break
        case 'MDV':
            return "/masterManagement-menudata-item2"
            break
        case 'HQD':
            return "/dashboard-management"
            break
        case 'DDM':
            return "/dashboard-management"
            break
        case 'DTCDB':
            return "/operationsMenu-menu-item2"
            break
        case 'CAD':
            return "/CAN-Alerts"
            break
        case 'CAND':
            return "/CAN-Condense-Alerts"
            break
        case 'SAD':
            return "/service-alerts"
            break
        case 'TLS':
            return "/viewtickets"
            break
        case 'TTS':
            return "/track-trace"
            break
        case 'MYA':
            return "/account-menu-item-view-1/users"
            break

    }
}
